import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { isChunkLoadError } from "./chunkError";

const RELOAD_FLAG = "chunk-reload-at";
const RELOAD_WINDOW_MS = 30_000;

function reloadedRecently(): boolean {
  try {
    const at = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
    return Date.now() - at < RELOAD_WINDOW_MS;
  } catch {
    return true; // sem storage nao ha como evitar laco: nao recarrega sozinho
  }
}

/** Tela de erro de rota. Para chunk velho, recarrega uma vez sozinha (o
 *  build novo e o que o usuario quer) e, se persistir, oferece o botao. */
export function RouteError() {
  const error = useRouteError();
  const stale = isChunkLoadError(error);

  useEffect(() => {
    if (!stale || reloadedRecently()) return;
    try {
      sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
    } catch {
      return;
    }
    window.location.reload();
  }, [stale]);

  return (
    <main
      className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center"
      role="alert"
    >
      <h1 className="text-2xl font-semibold">
        {stale ? "Há uma nova versão disponível" : "Algo deu errado"}
      </h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        {stale
          ? "Esta página foi atualizada. Recarregue para continuar."
          : "Não foi possível abrir esta página. Tente novamente."}
      </p>
      <button
        type="button"
        className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white"
        onClick={() => window.location.reload()}
      >
        Recarregar
      </button>
    </main>
  );
}
